import React from "react";
import { Button, Jumbotron } from "react-bootstrap";
import "./Banner1.css";
const Banner1 = () => {
  return (
    <div>
      <Jumbotron className="banner1 d-flex justify-content-center align-items-center mb-0">
        <div className="text-white font-weight-bold text-center">
          <h2 style={{ fontSize: "36px" }}>
            BRING ALL YOUR FRIENDS. GET 30% DISCOUNT!
          </h2>
          <p className="w-75 mx-auto">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa minus
            numquam fuga placeat perferendis earum quibusdam exercitationem
            laborum neque deleniti, inventore.
          </p>
          <p>
            <button>Learn more</button>
          </p>
        </div>
      </Jumbotron>
    </div>
  );
};

export default Banner1;
